import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "parent"
}
const _hoisted_2 = { class: "textInput" }
const _hoisted_3 = {
  class: "label",
  for: "tbox1"
}
const _hoisted_4 = { class: "counter" }
const _hoisted_5 = ["maxlength", "placeholder", "value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.showFields)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.Title), 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.remaningLengthDescription) + "/" + _toDisplayString(_ctx.maxDescription), 1),
          _createElementVNode("textarea", {
            class: "input",
            name: "tbox1",
            id: "tbox1",
            maxlength: _ctx.maxDescription,
            placeholder: _ctx.addDescription,
            rows: "8",
            cols: "33",
            value: _ctx.description,
            onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onChange', _ctx.handleEmit($event.target))))
          }, null, 40, _hoisted_5)
        ])
      ]))
    : _createCommentVNode("", true)
}